var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$companyConfiguration.evaluation.isEnabled())?_c('div',[_c('scales-component')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }